import React, { forwardRef } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import type { ClickableLinkProps } from './ClickableLink.types';

export const ClickableLink = forwardRef<HTMLAnchorElement, ClickableLinkProps>(
  ({ className, disabled, href, onClick, target, as, ...rest }, ref) => {
    const Component = as ?? 'a';

    const defaultClasses = [
      'aria-[disabled=true]:cursor-not-allowed',
      'aria-[disabled=true]:opacity-40',
      'aria-[disabled=true]:hover:opacity-40',
    ];

    return (
      <Component
        ref={ref}
        href={disabled ? undefined : href}
        aria-disabled={disabled}
        onClick={disabled ? undefined : onClick}
        role={disabled ? 'link' : undefined}
        target={disabled ? undefined : target}
        className={cn(defaultClasses, className)}
        {...rest}
      />
    );
  },
);
